import React, { useState } from 'react';

import SectionHeader from './SectionHeader';
import { useInitialHtml, useServerHtml } from '../../marketingRendering/InitialHtmlContext';

function PricingCards({ id, label, title, description, plans, includedItems = [], footnote, initialHtml = false }) {
  const serverHtml = useServerHtml();
  const initialPage = useInitialHtml();
  // The small initial-HTML script starts the existing AOS animations before
  // React loads. Adopt its current attributes without restarting an entrance
  // or asking React to overwrite an animation already in progress.
  const [motion] = useState(() => (initialHtml || initialPage) && !serverHtml && typeof document !== 'undefined'
    ? Array.from(document.querySelectorAll('.pricing-initial-html .tier, .home-initial-html .tier')).map((node) => ({
      classes: ['aos-init', 'aos-animate'].filter((name) => node.classList.contains(name)).join(' '),
      effect: node.getAttribute('data-aos') || undefined,
    })) : []);
  return (
    <section className="pricing" id={id}>
      <div className="container">
        <SectionHeader label={label} title={title} description={description} />

        <div className="tiers">
          {plans.map((plan, index) => {
            const ButtonTag = plan.buttonVariant === 'filled' ? 'md-filled-button' : 'md-outlined-button';

            return (
              <div
                className={`tier${plan.featured ? ' featured' : ''}${motion[index]?.classes ? ` ${motion[index].classes}` : ''}`}
                data-aos={motion[index] ? motion[index].effect : 'fade-up'}
                key={plan.title}
              >
                {plan.icon && (
                  <div className="tier-icon-row">
                    <span className={`material-symbols-outlined tier-icon-sym ${plan.iconTone}`}>
                      {plan.icon}
                    </span>
                  </div>
                )}
                <h3>{plan.title}</h3>
                <p className="tier-desc">{plan.description}</p>
                <div className="tier-price">
                  {plan.pricePrefix && <span className="per-from">{plan.pricePrefix}</span>}
                  <span className="amount">{plan.price}</span>
                  {plan.priceSuffix && <span className="per">{plan.priceSuffix}</span>}
                </div>
                <p className="tier-billing">{plan.billing}</p>
                <ButtonTag
                  href={plan.onClick ? undefined : plan.href}
                  onClick={serverHtml ? undefined : plan.onClick || undefined}
                  className="btn-lg"
                >
                  {plan.ctaLabel}
                </ButtonTag>
                {plan.fineprint && <p className="tier-fine">{plan.fineprint}</p>}
                <div className="tier-features">
                  <p className="tier-features-heading">{plan.featuresHeading}</p>
                  <ul>
                    {plan.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {includedItems.length > 0 && (
          <div className="plans-include">
            <span className="pi-title">All plans include:</span>
            {includedItems.map((item) => (
              <span className="pi-item" key={item}>{item}</span>
            ))}
          </div>
        )}

        {footnote && <p className="plans-note">{footnote}</p>}
      </div>
    </section>
  );
}

export default PricingCards;
